import React from 'react';
import { AlternateLanguage, PageContextType } from 'src/types';
import { Segment } from 'src/analytics';

export type AppContextType = {
    pageContext: PageContextType;
    isLoggedIn: boolean;
    logOut: () => void;
    alternateLanguages: AlternateLanguage[];
    options: {
        show_navigation_header: boolean;
        show_footer: boolean;
    };
    homePage: string | null;
    segment: Segment;
};

export const AppContext: React.Context<AppContextType> = React.createContext({
    pageContext: { id: '', type: '', lang: '', uid: '', url: '' },
    isLoggedIn: false,
    logOut: () => undefined,
    alternateLanguages: [{ id: '', type: '', lang: '', uid: '' }],
    options: { show_navigation_header: false, show_footer: false },
    homePage: '',
    segment: {} as Segment,
});

export function withAppContext(Component: any) {
    return (props: any) => (
        <AppContext.Consumer>
            {context => <Component {...props} context={context} />}
        </AppContext.Consumer>
    );
}
